<td class="month-column">
  {{ formattedMonth(requirement.month) }}
</td>
<td class="mr-auto">
  <span class="mr-2 circle-indicator" [ngClass]="{
    'text-danger': requirement.status === 'failed',
    'text-warning': requirement.status === 'unprocessed' || requirement.status === 'needed',
    'text-success': requirement.status === 'processing' || requirement.status === 'complete'
  }">
    <i class="fa fa-circle" *ngIf="requirement.status !== 'processing' && requirement.status !== 'complete'"></i>
    <i class="fa fa-check" *ngIf="requirement.status === 'processing' || requirement.status === 'complete'"></i>
  </span>

  {{ formattedStatus(requirement.status) }}
</td>
<td class="text-right">

  <div class="d-inline mr-2 text-drop text-only uib-dropdown" dropdown #docSelectDropdown="bs-dropdown" container="body">

    <a dropdownToggle class="req-doc-modify uib-dropdown-toggle">{{ attachLabel(requirement) }}</a>

    <div *dropdownMenu>
      <ul class="dropdown-menu show dropdown-menu-right uib-dropdown-menu" (click)="$event.stopPropagation()">
          <span class="cm-arrow"><span></span></span>

        <li class="dropdown-header">Add Attachment From</li>
        <div>
          <li class="pointer dropdown-item p-0">
            <input id="doc-upload" class="d-none" type="file" ng2FileSelect [uploader]="uploader" />
            <label class="w-100 mb-0 px-4 py-2" for="doc-upload">Computer</label>
          </li>

          <li class="pointer dropdown-item p-0">
            <document-attach
              [borrowerId]="borrowerId"
              [docFilter]="docFilter"
              (attached)="handleAttachment($event)"
              position="left"
            >
              Documents Tab
            </document-attach>
          </li>
        </div>
      </ul>
    </div>
  </div>

  <a *ngIf="requirement.documentId"
    class="req-doc-view align-middle"
    [ngClass]="{'disabled': !docIsClean}"
    [attr.title]="viewTitle"
    [attr.href]="viewHref"
    (click)="openDocument(requirement.documentId)"
  >
    View
  </a>

</td>
